<template>
  <b-form-group
    :label="$t('tasks.form.managers')"
    label-for="id_manager_users"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('tasks.form.managers')"
      :rules="Number(dataItem.is_public) ? '' : 'required'"
    >
      <v-select
        id="id_manager_users"
        v-model="dataItem.id_manager_users"
        :options="usersList"
        label="name"
        :reduce="item => item.id"
        :placeholder="$t('tasks.form.selectManager')"
        multiple
        :disabled="disabled"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
    <small class="text-muted">
      {{ hintText }}
    </small>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'TasksManagerUsersCard',
  components: { BFormGroup, ValidationProvider, vSelect },
  props: {
    storeModule: {
      type: String,
      default: 'tasks',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    hintText() {
      return this.hint ?? this.$t('tasks.form.managersHint')
    },
    usersList() {
      return this.$store.getters['users/dataList']
    },
    dataItem() {
      return this.$store.getters[`${this.storeModule}/dataItem`]
    },
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      this.$store.dispatch('users/getDataList', {
        select: ['users.id AS id', 'users.name AS name'],
        where: { 'users.status': 1 },
        limit: 500,
        start: 0,
      })
    },
  },
}
</script>
